import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const META_POLL_INTERVAL_MS = 15_000;
const META_REQUEST_TIMEOUT_MS = 10_000;
const IS_DEV = process.env.NODE_ENV === 'development';

const DEFAULT_META = {
  station: 'OSO London',
  song: 'Connecting…',
  listeners: 0,
  peak_listeners: 0,
  bitrate: '192',
  is_live: false,
  stream_url: process.env.REACT_APP_STREAM_URL,
};

/**
 * Polls the backend `/nowplaying` endpoint on a fixed cadence and exposes
 * the latest metadata payload. Errors are swallowed after a dev-only log
 * to keep the UI showing the last-known good values.
 */
export function useNowPlaying(apiBase) {
  const [nowPlaying, setNowPlaying] = useState(DEFAULT_META);

  const fetchMeta = useCallback(async () => {
    try {
      const r = await axios.get(`${apiBase}/nowplaying`, {
        timeout: META_REQUEST_TIMEOUT_MS,
      });
      setNowPlaying(r.data);
    } catch (err) {
      if (IS_DEV) {
        console.warn('nowplaying fetch failed:', err?.message || err);
      }
    }
  }, [apiBase]);

  useEffect(() => {
    fetchMeta();
    const id = setInterval(fetchMeta, META_POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [fetchMeta]);

  return { nowPlaying, refreshMeta: fetchMeta };
}
